import React, { useState } from 'react';
import axios from 'axios';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('Sending...');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/request-password-reset`,
        { email }
      );
      setMsg(response.data.message || 'If that email exists, a reset link has been sent.');
      if (response.data.warning) {
        setMsg(prev => prev + ' (Note: Email service may not be configured)');
      }
    } catch (error) {
      console.error('Password reset request error:', error);
      setMsg('An error occurred. Please try again later.');
    }
  };

  //git comment

  return (
    <div className="login-container">
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button type="submit">Send Reset Link</button>
      </form>
      {msg && <p>{msg}</p>}
    </div>
  );
}

export default ForgotPassword;